import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

/**
 * <SetItemAmountDialog template item amount repeat onSetAmount = {template, item, amount, repeat} onCancel = {} />
 */

class SetItemAmountDialog extends Component {

	state = {
		amount: "",
		repeat: false,
	}

	componentDidMount() {
		this.setState({
			amount: this.props.amount,
			repeat: this.props.repeat === '1',
		})
	}

	isUnsignedNumber(value) {
		let s = value.toString()
		for (let i = 0; i < s.length; i++) {
			if ((s[i] < '0') || (s[i] > '9')) {
				return false
			}
		}
		return true
	}

	isReadyToCreate() {
		return this.state.amount !== "" && this.isUnsignedNumber(this.state.amount)
	}

	render() {
		return <Dialog
			open = {true}
			scroll = "body"
		>
			<DialogTitle>
				Количество предметов
			</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.amount}
					label = "Количество предметов"
					margin = "normal"
					onChange = {e => {
						this.setState({
							amount: e.target.value
						})
					}}
				/>

				<FormGroup row>
	        <FormControlLabel
	          control={
	            <Checkbox
	              checked={this.state.repeat}
	              onChange={e => {
									e.stopPropagation()
									this.setState({
										repeat: e.target.checked,
									})
								}}
	            />
	          }
	          label="Повторять"
	        />
				</FormGroup>

			</DialogContent>
			<DialogActions>
				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSetAmount === "function") {
							this.props.onSetAmount(this.props.template, this.props.item, this.state.amount, this.state.repeat ? '1' : '0')
						}
					}}
				>Ок</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>

	}

}

export default SetItemAmountDialog
